import { render, staticRenderFns } from "./businesshospitalrelationshiptable.vue?vue&type=template&id=07bd9bd8&scoped=true&"
import script from "./businesshospitalrelationshiptable.vue?vue&type=script&lang=js&"
export * from "./businesshospitalrelationshiptable.vue?vue&type=script&lang=js&"
import style0 from "./businesshospitalrelationshiptable.vue?vue&type=style&index=0&id=07bd9bd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd9bd8",
  null
  
)

export default component.exports